import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DataProvider, useData } from './backend/firebase'; 
import { HelmetProvider } from 'react-helmet-async'; // <--- IMPORT THIS
import './App.css';

import SideBar from './components/Sidebar';
import LoadingScreen from './components/LoadingScreen'; // Import new component
import Home from './pages/Home';
import Rules from './pages/Rules';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Schedule from './pages/Schedule';
import Standings from './pages/Standings';
import Archive from './pages/Archive';
import Donations from './pages/Donations';
import CustomPage from './pages/CustomPage';
import RouteGuard from './components/RouteGuard';
import CaptainPortal from './pages/CaptainPortal';

// Inner App to access Context
const MainApp = () => {
    const { globalStyle, loading } = useData();

    // Apply Styles Dynamically
    useEffect(() => {
        if(globalStyle) {
            const root = document.documentElement;
            if(globalStyle.font) root.style.setProperty('font-family', `'${globalStyle.font}', sans-serif`);
            if(globalStyle.accentColor) root.style.setProperty('--accent-color', globalStyle.accentColor);
            if(globalStyle.sidebarBg) root.style.setProperty('--sidebar-bg', globalStyle.sidebarBg);
            if(globalStyle.cardBg) root.style.setProperty('--card-bg', globalStyle.cardBg);
            if(globalStyle.bgStart) root.style.setProperty('--bg-gradient-start', globalStyle.bgStart);
            if(globalStyle.bgEnd) root.style.setProperty('--bg-gradient-end', globalStyle.bgEnd);
        }
    }, [globalStyle]);

    // --- SHOW LOADING SCREEN UNTIL DATA IS READY ---
    if (loading) {
        return <LoadingScreen />;
    }

    return (
        <div className="App">
          <SideBar />
          <Routes>
            <Route path="/" element={<RouteGuard><Home /></RouteGuard>} />
            <Route path="/schedule" element={<RouteGuard><Schedule /></RouteGuard>} />
            <Route path="/standings" element={<RouteGuard><Standings /></RouteGuard>} />
            <Route path="/archive" element={<RouteGuard><Archive /></RouteGuard>} />
            <Route path="/rules" element={<RouteGuard><Rules /></RouteGuard>} />
            <Route path="/donate" element={<RouteGuard><Donations /></RouteGuard>} />
            <Route path="/page/:slug" element={<RouteGuard><CustomPage /></RouteGuard>} />
            
            
            <Route path="/captain" element={<CaptainPortal />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
    );
}

function App() {
  return (
    <HelmetProvider>
      <DataProvider>
        <BrowserRouter>
          <MainApp />
        </BrowserRouter>
      </DataProvider>
    </HelmetProvider>
  );
}

export default App;